<template>
    <div class="form-input form-input-checkbox">
        <div class="form-input-header">
            <div class="label">{{ label }}</div>
            <div v-if="note" class="note">{{ note }}</div>
        </div>
        <div class="form-input-field form-input-field--line">
          <div class="checkbox-option option">
                <label class="form-input-radio-label" :class="selectAll ? 'bold' : ''">
                    <input type="checkbox" v-model="selectAll" />
                    <span></span>
                    {{ $t('general.form.buttons.all') }}
                </label>
            </div>
            <div v-for="item in options" :key="item.value" class="checkbox-option option">
                <label class="form-input-radio-label" :class="value === item.value ? 'bold' : ''">
                    <input type="checkbox" :value="item.value" v-model="checkboxValue" />
                    <span></span>
                    {{ item.title }}
                </label>
            </div>
            <div v-if="errorHas" class="form-input-error">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputCheckbox',
    props: {
        value: {
            type: Array,
            required: true,
        },
        options: {
            type: Array,
            required: false,
        },
        errors: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        note: {
            type: String,
            required: false,
        },
    },
    computed: {
        selectAll: {
            get() { return this.value.length === this.options.length; },
            set(newValue) {
                let selected = [];
                if (newValue) {
                    selected = this.options.map((option) => option.value);
                }

                this.$emit('input', selected);
            },
        },
        checkboxValue: {
            get() { return this.value; },
            set(newValue) {
                console.log(newValue);
                this.$emit('input', newValue);
            },
        },
        errorHas() {
            return this.errors && typeof this.errors[this.field] !== 'undefined' && this.errors[this.field];
        },
        errorMessage() {
            return this.errors[this.field].join('<br/>');
        },
    },
};
</script>
